<script lang="ts">
	import "tippy.js/dist/tippy.css";

	import Login from "./Login.svelte";
	import { Router, Route, Link } from "svelte-navigator";
	import RecipePlanner from "./recipes/RecipePlanner.svelte";
	import CookRecipeView from "./recipes/CookRecipeView.svelte";

	import { user_token } from "./jwt_store";
	import EditRecipe from "./recipes/EditRecipe.svelte";
	import ViewRecipes from "./recipes/ViewRecipes.svelte";
	import ImportRecipe from "./recipes/ImportRecipe.svelte";
	import Settings from "./user/Settings.svelte";
	import ProcessAuthToken from "./user/ProcessAuthToken.svelte";
	import ImportRecipeFromUrl from "./recipes/ImportRecipeFromURL.svelte";
	import ViewGroceryList from "./recipes/ViewGroceryList.svelte";
	import ViewAllGroceryLists from "./recipes/ViewAllGroceryLists.svelte";
	import ProcessCognitoAuthToken from "./user/ProcessCognitoAuthToken.svelte";

	// import Gear from "./icons/Gear.svelte";
</script>

<Router primary={false}>
	<div class="header">
		<div class="header-left">
			<Link to="/">Home</Link>
			<Link to="planner">Planner</Link>
			<Link to={"grocery-list"}>Grocery List</Link>
			<Link to={"recipe"}>My Recipes</Link>
			<Link to={"recipe/import"}>Import New Recipe</Link>
		</div>
		<div class="header-right">
			{#if $user_token != ""}
				<!-- <Link to="settings"><Gear /></Link> -->
				<div class="logout" on:click={() => ($user_token = "")}>
					Logout
				</div>
			{/if}
		</div>
	</div>
	<main>
		{#if $user_token == ""}
			<Login />
			<Route path="/cognito/login">
				<ProcessCognitoAuthToken />
			</Route>
		{:else}
			<Route path="/">
				<div class="title">Welcome To Tastummy</div>
			</Route>
			<Route path="settings">
				<Settings />
			</Route>
			<Route path="auth">
				<ProcessAuthToken />
			</Route>
			<Route path="planner">
				<RecipePlanner />
			</Route>
			<Route path="grocery-list">
				<ViewAllGroceryLists />
			</Route>
			<Route path="grocery-list/:id">
				<ViewGroceryList />
			</Route>
			<Route path="recipe">
				<ViewRecipes />
			</Route>
			<Route path="recipe/:id">
				<CookRecipeView />
			</Route>
			<Route path="recipe/:id/edit">
				<EditRecipe />
			</Route>
			<Route path="recipe/:id/import">
				<ImportRecipe />
			</Route>
			<Route path="recipe/import">
				<ImportRecipeFromUrl />
			</Route>
		{/if}
	</main>
</Router>

<style>
	main {
		text-align: center;
		padding: 1em;
	}
	.title {
		font-size: 3em;
	}
	.logout {
		color: var(--link);
		display: inline;
		cursor: pointer;
	}
	.logout:hover {
		text-decoration: underline;
	}
	.header {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		padding: 1em;
		background-color: var(--background-2);
	}
	.header-left {
		grid-column: 1 / 3;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
		column-gap: 1em;
	}
	.header-right {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: flex-end;
		column-gap: 1em;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
